import React from 'react'
import Modal from 'react-modal'

export default function CustomNotificationModal(props) {
    let zindexOverly = props.zIndex ? props.zIndex : 10000000;
    const customStyles = !props.modalType ? {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: zindexOverly,
            backgroundColor: 'rgba(225, 225, 225, 0.547)'
        },
        content: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '1000px',
            height: '700px',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',


        },
    } : {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: zindexOverly,
            backgroundColor: 'rgba(225, 225, 225, 0.547)',

        },
        content: {
            position: 'absolute',
            padding: 0,
            border: '0px solid',
            height: '90vh',
            overflow: 'auto',
            background: '#fefefe',
            boxShadow: '0 0 5pt #85878a !important',
        },
    }

    function handleRequestClose() {
        if (props.onRequestClose) {
            props.onRequestClose();
        }
    }

    return (
        <div>
            <Modal
                isOpen={props.isOpen}
                style={customStyles}
                // overlayClassName="overlay"
                contentLabel="onRequestClose Example"
                
            >

                {/* <div class="modal-dialog modal-dialog-centered">
                
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title"><img src='content/theme/assets/images/process2.png'/> Approval</h3>
             
                        </div>
                        <div class="modal-body " >
                        
                            {props.children}
                        </div>
                    </div>
    </div>*/}
                <div class="card ribbon-box">
                    <div class="card-body">
                        <div class="ribbon ribbon-primary float-start"><i class="mdi mdi-check-decagram-outline me-1"></i> Approval</div>
                        <button type="button" class="btn-close btn-danger float-end mt-0" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleRequestClose()}></button>
                        <div class="ribbon-content">
                            {props.children}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>

    );
}
